import { render, staticRenderFns } from "./MessageLocation.vue?vue&type=template&id=190aacb3&"
import script from "./message-location.ts?vue&type=script&lang=ts&"
export * from "./message-location.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports